module.exports = __webpack_public_path__ + "static/media/question.efc89efd.svg";